import { render, staticRenderFns } from "./SocialTwo.vue?vue&type=template&id=05eac17e&"
import script from "./SocialTwo.vue?vue&type=script&lang=js&"
export * from "./SocialTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports